import { atsRequest, axiosRequest } from "../../configs/axios.config";

export class TemplatesService {
  getAll(idResource, success, error) {
    atsRequest
      .get(
        `/rankmi-templates/ats_templates/workspace/templates?resource=${idResource}&lang=es`
      )
      .then(({ data }) => success(data.data))
      .catch((errorResp) => error(errorResp));
  }
  getAll2(type,success, error) {
    axiosRequest.get(
      `/report_templates?workspace=${type}`
    )
    .then(({ data }) => success(data))
    .catch((errorResp) => error(errorResp));
  }

  getAllByProfile(idResource, profile, success, error) {
    atsRequest
      .get(
        `/rankmi-templates/ats_templates/workspace/${profile}/templates?resource=${idResource}&lang=es`
      )
      .then(({ data }) => success(data.data))
      .catch((errorResp) => error(errorResp));
  }
}
